import Translate from '../lib/translate'

const TranslatePlugin = {
  install(Vue, { translations, defaultLang }) {
    const translate = new Translate({
      translations,
      defaultLang
    })

    Object.defineProperty(Vue.prototype, '$translate', { value: translate })

    function humanize(key) {
      const [firstLetter, ...rest] = key
      return `${firstLetter.toUpperCase()}${rest.join('')}`.replace(/_/g, ' ').trim()
    }

    Object.defineProperty(Vue.prototype, '$humanize', { value: humanize })

    const attributes = [
      'translate',
      'translateParams',
      'translateAlt',
      'translateLang'
    ]

    function updateElem(el) {
      const opts = {}
      attributes.forEach((attr) => {
        let value
        try {
          value = JSON.parse(el.dataset[attr])
        } catch (error) {
          value = el.dataset[attr]
        }
        opts[attr] = value
      })
      el.innerHTML = translate.instant(opts)
    }

    function createDirective(attr) {
      Vue.directive(attr, (el, binding) => {
        el.dataset[attr] = typeof binding.value === 'object'
          ? JSON.stringify(binding.value)
          : binding.value
        updateElem(el)
      })
    }

    attributes.forEach(createDirective)
  }
}

export default TranslatePlugin
